import type { NavigateFunction } from 'react-router-dom'

import { isValidWorkflowDefinitionPublicId, isValidWorkflowRunPublicId } from '../../api/workflowRuns'

export const WORKFLOW_SIMULATE_RUN_ID = 'simulate'
export const WORKFLOW_SIMULATE_SESSION_KEY = 'glyphic:workflow-simulate-payload'

export type WorkflowSimulateSessionPayload = {
  definitionId: string
  definitionName?: string
  input: Record<string, unknown>
  from?: 'builder' | 'list'
}

export function workflowRunPagePath(runId: string) {
  if (!isValidWorkflowRunPublicId(runId)) return '/workflows'
  return `/workflows/runs/${encodeURIComponent(runId)}`
}

/** 模拟运行挂在编排器路径下，面包屑与编排页连续 */
export function workflowSimulatePagePath(definitionId: string) {
  if (!isValidWorkflowDefinitionPublicId(definitionId)) return '/workflows'
  return `/workflows/builder/${encodeURIComponent(definitionId)}/simulate`
}

export function isWorkflowSimulatePagePath(pathname: string): boolean {
  return /\/workflows\/builder\/[^/]+\/simulate\/?$/.test(pathname)
}

export function isSimulatedWorkflowRunId(runId: string | undefined) {
  return runId?.trim() === WORKFLOW_SIMULATE_RUN_ID
}

export function readWorkflowSimulateSession(): WorkflowSimulateSessionPayload | null {
  try {
    const raw = sessionStorage.getItem(WORKFLOW_SIMULATE_SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as WorkflowSimulateSessionPayload
    const definitionId = String(parsed?.definitionId ?? '').trim()
    if (!isValidWorkflowDefinitionPublicId(definitionId)) return null
    return {
      definitionId,
      definitionName: parsed.definitionName?.trim() || undefined,
      input: parsed.input && typeof parsed.input === 'object' ? parsed.input : {},
      from: parsed.from,
    }
  } catch {
    return null
  }
}

export function writeWorkflowSimulateSession(payload: WorkflowSimulateSessionPayload) {
  sessionStorage.setItem(WORKFLOW_SIMULATE_SESSION_KEY, JSON.stringify(payload))
}

export function navigateToSimulatedWorkflowRun(
  navigate: NavigateFunction,
  payload: WorkflowSimulateSessionPayload,
) {
  if (!isValidWorkflowDefinitionPublicId(payload.definitionId)) return
  writeWorkflowSimulateSession(payload)
  navigate(workflowSimulatePagePath(payload.definitionId))
}
